// 以美金「顯示」價格的語系（繁中以外）。金流頁用來決定預設顯示幣別；
// 使用者在帳單資訊選了國家後，改以國家為準（見 setting-upgrade 的 isUsd）。
// 後端目前一律以台幣扣款，美金僅為顯示換算
export const USD_LANGUAGES = ['en', 'ja', 'es'];

// i18next.language 在初始化前可能是 undefined，所以參數允許空值
export const isUsdLanguage = (language?: string | null): boolean =>
  !!language && USD_LANGUAGES.some((code) => language.includes(code));
